module.exports = __webpack_public_path__ + "static/media/exhibition-services-img9.877bbfd4.jpg";